import React, { useMemo, useState } from 'react';
import DropdownMenu, { DropdownItemCheckbox, DropdownItemGroupCheckbox } from '@atlaskit/dropdown-menu';
import { SupportIssueStatusTypeConstants } from '@atlassian/cssxp-utils-support';
import { SupportIssueStatusEnum } from '@atlassian/cssxp-types-support';

export type SupportIssueSelectedStatuses = {
  [k in SupportIssueStatusEnum]: boolean;
};

interface Props {
  onChange: (changeObj: SupportIssueSelectedStatuses) => void;
}
const SupportIssueStatusFilter = React.memo(({ onChange }: Props) => {
  const supportTypes = useMemo(() => {
    return SupportIssueStatusTypeConstants.sort((a, b) => a.order - b.order);
  }, []);
  const [selected, updateSelected] = useState<SupportIssueSelectedStatuses>();

  const toggleSelection = (name: SupportIssueStatusEnum) => {
    const _selected = {
      ...selected,
    };
    if (_selected && _selected[name]) {
      delete _selected[name];
    } else {
      _selected[name] = true;
    }
    updateSelected(_selected as SupportIssueSelectedStatuses);
    onChange(_selected as SupportIssueSelectedStatuses);
  };

  return (
    <div className="status-filter">
      <DropdownMenu
        trigger="Status: All"
        triggerType="button"
        position="bottom left"
        testId="support-issue-status-filter"
        triggerButtonProps={{
          className: 'trigger-button',
        }}
      >
        <DropdownItemGroupCheckbox id="status-types">
          {supportTypes.map((supportType) => {
            return (
              <DropdownItemCheckbox
                id={supportType.name}
                key={supportType.name}
                onClick={() => toggleSelection(supportType.name)}
                isSelected={selected && selected[supportType.name]}
              >
                {supportType.name}
              </DropdownItemCheckbox>
            );
          })}
        </DropdownItemGroupCheckbox>
      </DropdownMenu>
    </div>
  );
});

SupportIssueStatusFilter.displayName = 'SupportIssueStatusFilter';

export { SupportIssueStatusFilter };
